var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoxyPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74512 6.87164V10.6232H7.49668",
    stroke: "#307EC5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81934 16.2505C4.45627 21.8673 9.1661 26.1369 14.8183 26.2214C20.4705 26.3058 25.3058 22.1788 26.1102 16.5836C26.9147 10.9883 23.438 5.66623 17.9909 4.15487C12.5439 2.64352 6.82199 5.41327 4.62842 10.6231",
    stroke: "#307EC5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0776 15.1873L9.69522 17.5746C9.48938 17.7822 9.37362 18.0624 9.37305 18.3548V19.5237C9.37305 19.8164 9.48931 20.0971 9.69626 20.3041C9.90322 20.511 10.1839 20.6273 10.4766 20.6273H11.6505C11.9435 20.6277 12.2244 20.5108 12.4306 20.3027L14.8081 17.9203C15.2435 18.0727 15.7009 18.1532 16.1622 18.1585C18.0781 18.1901 19.7934 16.9762 20.4011 15.159C21.0087 13.3418 20.3684 11.3403 18.8189 10.2131C17.2693 9.08597 15.168 9.09311 13.6261 10.2308C12.0843 11.3685 11.4577 13.3742 12.0776 15.1873V15.1873Z",
    stroke: "#307EC5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1624 13.7875C16.1344 13.7875 16.1118 13.8102 16.1118 13.8382C16.1118 13.8661 16.1344 13.8888 16.1624 13.8888C16.1903 13.8888 16.213 13.8661 16.213 13.8382C16.213 13.8102 16.1903 13.7875 16.1624 13.7875V13.7875",
    stroke: "#307EC5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoxyPassword);
export default __webpack_public_path__ + "static/media/moxy-password.3d5471c2c85f4f8d58f96da5b62fc560.svg";
export { ForwardRef as ReactComponent };